module.exports = __webpack_public_path__ + "img/epay-lkl.ec7772ac.png";